<template>
  <d-form @submit.prevent="save" :validated="hasErrors">
    <d-form-row>
      <!-- Nome -->
      <d-col lg="7" md="12" class="form-group">
        <label for="name">Nome</label>
        <d-form-input
          :state="hasErrorFiled('name')"
          type="text"
          id="name"
          placeholder="Nome"
          v-model="model.name"
        />
        <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Email -->
      <d-col lg="5" md="6" class="form-group">
        <label for="feContactEmail">E-mail</label>
        <d-form-input
          :state="hasErrorFiled('email')"
          type="email"
          v-model="model.email"
          id="feContactEmail"
          placeholder="E-mail"
        />
        <d-form-invalid-feedback>E-mail é obrigatório</d-form-invalid-feedback>
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Telefone -->
      <d-col md="4" class="form-group">
        <label for="feTelefone">Telefone</label>
        <input-phone
          id="feTelefone"
          :model.sync="model.phone"
          :state="hasErrorFiled('phone')"
        ></input-phone>
        <d-form-invalid-feedback
          >Telefone é obrigatório</d-form-invalid-feedback
        >
      </d-col>

      <!-- Celular -->
      <d-col md="4" class="form-group">
        <label for="feCelular">Celular</label>
        <input-phone id="feCelular" :model.sync="model.cellphone"></input-phone>
      </d-col>

      <!-- Site -->
      <d-col md="4" class="form-group">
        <label for="feSite">Site</label>
        <d-form-input
          type="text"
          id="feSite"
          placeholder="Site"
          v-model="model.site"
        />
      </d-col>
    </d-form-row>

    <d-form-row>
      <!-- Facebook -->
      <d-col md="4" class="form-group">
        <label for="feFacebook">Facebook</label>
        <d-form-input
          type="text"
          id="feFacebook"
          placeholder="Facebook"
          v-model="model.social_medias.facebook"
        />
      </d-col>

      <!-- Instagram -->
      <d-col md="4" class="form-group">
        <label for="feInstagram">Instagram</label>
        <d-form-input
          type="text"
          id="feInstagram"
          placeholder="Instagram"
          v-model="model.social_medias.instagram"
        />
      </d-col>
    </d-form-row>

    <d-form-row>
      <d-tabs class="px-1 mb-4 w-100" ref="tabs">
        <d-tab title="Endereço" class="p-1 pt-3">
          <addresses
            :model.sync="model.address"
            @changeCep="setCoordenate"
            ref="address"
          />
          <d-form-row class="px-3">
            <!-- Latitude -->
            <d-col md="4" class="form-group">
              <label for="feLatitude">Latitude</label>
              <d-form-input
                type="number"
                step="0.0001"
                id="feLatitude"
                placeholder="Latitude"
                v-model="model.lat"
              />
            </d-col>
            <!-- Longitude -->
            <d-col md="4" class="form-group">
              <label for="feLongitude">Longitude</label>
              <d-form-input
                type="number"
                step="0.0001"
                id="feLongitude"
                placeholder="Longitude"
                v-model="model.lng"
              />
            </d-col>
          </d-form-row>
          <div class="px-3 mb-3" v-if="model.lat && model.lng">
            <google-map :lat="model.lat" :lng="model.lng" />
          </div>
        </d-tab>
        <d-tab title="Indicações" class="p-1 pt-3" v-if="model.id">
          <indicators :id="model.id" ref="indicators" />
        </d-tab>
        <d-tab
          title="Representantes"
          class="p-1 pt-3"
          v-if="isAdmin || isCommercial"
        >
          <representatives
            :model.sync="model.representatives"
            :resellerId="model.id"
            ref="representatives"
          />
        </d-tab>
      </d-tabs>
    </d-form-row>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import mixin from '_common/mixins/ValidateForm';
import formatErrors from '_common/mixins/FormatErrors';
import Events from '_utils/events';
import InputPhone from '_shared/InputPhone.vue';
import GoogleMap from '_shared/GoogleMap.vue';
import ResellerService from '_services/rest/modules/reseller';
import { cloneDeep, capitalize } from '_utils';
import Indicators from './Indicators.vue';
import Addresses from './Addresses.vue';
import Representatives from './RepresentativesForm.vue';
import { MODEL, _LOAD_MODEL_, _SAVE_RESELLER_SUCCESS_ } from './ResellerModel';

export default {
  name: 'reseller-form',
  mixins: [mixin, formatErrors],
  components: {
    Addresses,
    GoogleMap,
    Indicators,
    InputPhone,
    Representatives,
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      loading: false,
      errors: {
        name: { required: false },
        email: { required: false },
        phone: { required: false },
        contacts_name: { required: false },
      },
    };
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
  },
  methods: {
    ...mapActions(['activeAlert', 'checkAdmin']),
    capitalizeInput(field) {
      this.model[field] = capitalize(this.model[field]);
    },
    setCoordenate(address) {
      ResellerService.getCoordenates(address).then(response => {
        const { location } = response[0].geometry;
        this.model.lat = location.lat.toString();
        this.model.lng = location.lng.toString();
      });
    },

    save() {
      if (this.checkForm()) {
        this.toggleLoading();
        ResellerService.save(this.model)
          .then(response => {
            this.success(response);
          })
          .catch(error => {
            this.toggleLoading();
            this.showError(error);
          });
      }
      return null;
    },
    success(resellerSaved) {
      this.toggleLoading();
      this.activeAlert({
        message: 'Parceiro salvo com sucesso',
        theme: 'success',
      });
      Events.$emit(_SAVE_RESELLER_SUCCESS_, resellerSaved);
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
    updateTabs() {
      setTimeout(() => {
        if (this.$refs.tabs) {
          this.$refs.tabs.updateTabs();
        }
      }, 10);
    },
  },
  mounted() {
    this.checkAdmin();
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = { ...newValue };
      this.updateTabs();
    });
  },
  destroyed() {
    Events.$off(_LOAD_MODEL_);
  },
};
</script>

<style lang="scss" scoped>
.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
</style>
